import { call, put, debounce } from 'redux-saga/effects'
import locationTyes from './locationsTypes'
import * as locationActions from './locationsActions'
import LocationsServices from '../../services/LocationsService/locationsService'

function * fetchOriginLocations ({ payload }) {
  try {
    const { offset } = payload
    yield put(locationActions.startOriginLocationsRequest(payload))
    const { data } = yield call(LocationsServices.fetchLocations, payload)
    yield put(locationActions.fethOriginSuccess({ data, offset }))
  } catch (e) {
    // yield put(locationActions.fethOriginSuccess())
  }
}

function * fetchDestinationLocations ({ payload }) {
  try {
    const { offset } = payload
    yield put(locationActions.startDestinationLocationsRequest(payload))
    const { data } = yield call(LocationsServices.fetchLocations, payload)
    yield put(locationActions.fethDestinationSuccess({ data, offset }))
  } catch (e) {
    // yield put(locationActions.fethDestinationSuccess(response.data))
  }
}

export function * locationsSaga () {
  yield debounce(500, locationTyes.FETCH_ORIGIN_LOCATIONS, fetchOriginLocations)
  yield debounce(500, locationTyes.FETCH_DESTINATION_LOCATIONS, fetchDestinationLocations)
}
